import { Pipe, PipeTransform } from '@angular/core';
import { Container } from '../../models/container';

@Pipe({ name: 'containerTypeFilterPipe' })
export class ContainerTypeFilterPipe implements PipeTransform {
    transform(allContainer: Container[], typeId: number) {
        return allContainer.filter(container => container.type.id === typeId);
    }
}
